/* eslint-disable @typescript-eslint/naming-convention */
import { Nullable, StrictOmit } from '@enmon/commons';
import { MeterDetailWater } from '@enmon/commons/lib/enmon';
import { Form } from 'antd';
import { FormItemProps } from 'components/Form/FormItem';
import { WaterMeterDetailField } from 'components/Form/meter_details/water/constants';
import { WaterDetails } from 'components/Form/meter_details/water/WaterDetails';
import { VFC } from 'react';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';

export type MeterWaterDetails = StrictOmit<
  MeterDetailWater,
  'secondSerialNumber' | 'hotWater' | 'flange' | 'woltman' | 'tubeMaterial'
> & {
  flowrate?: {
    value: number | null;
    unit: string | null;
  } | null;
};

export interface MeterWaterDetailsProps extends MeterWaterDetails {
  onFormItemReset: (name: FormItemProps['name']) => void;
}

export const WaterMeterDetails: VFC<MeterWaterDetailsProps> = props => {
  const { orientation, flowrate, layLength, diameterNominal, onFormItemReset } = props;

  const form = Form.useFormInstance();
  const flowrateUnit = Form.useWatch<Nullable<string>>(['detail', 'flowrate', 'unit'], form) ?? flowrate?.unit;
  const flowrateValue = Form.useWatch<Nullable<number>>(['detail', 'flowrate', 'value'], form) ?? flowrate?.value;

  const { setDetailsStepValues, detail } = useReplaceMeterStore();

  const handleFlowrateReset = () => {
    const emptyFlowrateValue = {
      detail: { ...detail, flowrate: { value: null, unit: null } } as MeterWaterDetails,
    };

    form.setFieldsValue({ detail: { flowrate: { value: null, unit: null } } });

    setDetailsStepValues(emptyFlowrateValue);
  };

  return (
    <WaterDetails
      itemsConfig={{
        [WaterMeterDetailField.Orientation]: {
          formItemProps: { initialValue: orientation, isSemiRequired: true, onResetField: onFormItemReset },
        },

        [WaterMeterDetailField.Flowrate]: {
          formItemProps: {
            isSemiRequired: true,
            onResetField: handleFlowrateReset,
          },
          additionalConfig: {
            flowrateUnit,
            flowrateValue,
          },
        },
        [WaterMeterDetailField.LayLength]: {
          formItemProps: { initialValue: layLength, isSemiRequired: true, onResetField: onFormItemReset },
        },
        [WaterMeterDetailField.DiameterNominal]: {
          formItemProps: { initialValue: diameterNominal, isSemiRequired: true, onResetField: onFormItemReset },
        },
      }}
    />
  );
};
